import React, { ReactNode, useState } from "react";

const Tooltip = ({
  children,
  content,
  align = "left",
}: {
  children: ReactNode;
  content?: string | ReactNode | ReactNode[];
  align?: "left" | "right";
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const isTouchDevice = () =>
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  if (!content) {
    return <div className="inline-block">{children}</div>;
  }

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => !isTouchDevice() && setIsVisible(true)}
        onMouseLeave={() => !isTouchDevice() && setIsVisible(false)}
        onFocus={() => !isTouchDevice() && setIsVisible(true)}
        onBlur={() => !isTouchDevice() && setIsVisible(false)}
        tabIndex={0}
      >
        {children}
      </div>
      {isVisible && !isTouchDevice() && (
        <div
          role="tooltip"
          className={`absolute z-10 px-3 py-2 text-sm font-medium pointer-events-none
            text-gray-900 bg-white transition-opacity duration-300 rounded-lg
            shadow-sm dark:bg-gray-900 dark:text-white top-full mt-1 ${
              align === "right" ? "right-0" : "left-0"
            } w-64 leading-relaxed`}
        >
          <div className="whitespace-pre-wrap">{content}</div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
